import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

import { useUsersService } from '~/core/services'

const staleTime = 24 * 60 * 60 * 1000 // 24H
export const useFavorite = () => {
  const queryClient = useQueryClient()
  const { displayToast } = useUiStore()
  const userStore = useUserStore()
  const { getFavorites, deleteFavorite, postFavorite } = useUsersService()
  const { isLogged } = storeToRefs(userStore)

  const canFetchFavorites = computed(() => isLogged.value)

  const { data: favorites, isFetching: isFetchingFavorites } = useQuery({
    enabled: canFetchFavorites,
    queryKey: ['me', 'favorites'],
    queryFn: getFavorites,
    staleTime,
  })

  const { mutate: mutateDeleteFavorite } = useMutation({
    mutationFn: (g: { id: number, name: string }) => deleteFavorite(g.id),
    onSuccess: (_, g) => {
      const data = favorites.value?.data?.filter((golf) => golf.id !== g.id)
      queryClient.setQueryData(['me', 'favorites'], { ...favorites.value, data })
      displayToast(`${g.name} a bien été supprimé de vos favoris.`, 'success', 2000)
    },
    onError: (err) => {
      displayToast(err.message, 'error', 2000)
    },
  })

  const { mutate: mutateAddFavorite } = useMutation({
    mutationFn: (g: { id: number, name: string }) => postFavorite(g.id),
    onSuccess: (res, g) => {
      const data = favorites.value?.data ? [...favorites.value.data, res?.data] : [res?.data]
      queryClient.setQueryData(['me', 'favorites'], { ...favorites.value, data })
      displayToast('addFavorite complete', 'success', 2000)
      displayToast(`${g.name} a bien été ajouté à vos favoris.`, 'success', 2000)
    },
    onError: (err) => {
      displayToast(err.message, 'error', 2000)
    },
  })

  function toggleFavorite(g: { id: number, name: string }, deletion = false) {
    if (deletion) {
      mutateDeleteFavorite(g)
    } else {
      const exist = favorites.value?.data?.find(({ id }) => g.id === id)
      const fn = exist ? mutateDeleteFavorite : mutateAddFavorite
      fn(g)
    }
  }

  return {
    favorites,
    isFetchingFavorites,
    toggleFavorite,
  }
}
